import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Fait défiler vers l'ancre du hash après changement de route ou chargement initial.
// Nécessaire parce que React rend le contenu APRÈS que le navigateur ait déjà
// tenté (et échoué) de scroller vers l'élément qui n'existait pas encore dans le DOM.
export default function ScrollToHash() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (!hash) {
            window.scrollTo({ top: 0, behavior: "instant" });
            return;
        }
        const id = hash.replace(/^#/, "");
        // Retry pattern — laisse le temps au contenu (ex : BookingSection) de rendre
        let attempts = 0;
        let timerId = null;
        let cancelled = false;
        const tryScroll = () => {
            if (cancelled) return;
            const el = document.getElementById(id);
            if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "start" });
                return;
            }
            if (attempts++ < 10) timerId = setTimeout(tryScroll, 120);
        };
        tryScroll();
        return () => {
            cancelled = true;
            if (timerId) clearTimeout(timerId);
        };
    }, [pathname, hash]);

    return null;
}
